import merge from 'lodash/merge.js';

import RubricBank from '@/store/modules/rubricbanks/RubricBank.js';
import Collection from '@/store/quill/Collection.js';
import EdverumTable from '@/store/utilities/EdverumTable.js';

const collectionHelpers = EdverumTable.collection('rubricBank');

export default merge(Collection('RubricBanks', RubricBank), {
    state: {
        sort: {
            id: null,
            title: null,
            updated_at: null,
        },
    },

    getters: {
        ...collectionHelpers.getters,
    },

    actions: {
        addRubricTemplateBank: collectionHelpers.actions.addModel(),

        clearSort: collectionHelpers.actions.clearSort,

        paginateAndFetch: collectionHelpers.actions.paginateAndFetch,

        fetch: collectionHelpers.actions.fetch(({ context, queryBuilder }) => {
            const { getters, rootGetters } = context;
            queryBuilder.include(['tags', 'groups']).sort(getters.queryBuilderSorting).setPagination(getters.paginate);

            if (rootGetters['RubricBanksView/hasQuery']) {
                queryBuilder.raw({
                    'filter[title]': rootGetters['RubricBanksView/searchQuery'],
                });
            }

            if (rootGetters['RubricBanksView/hasTagSearch']) {
                queryBuilder.raw({
                    tags: rootGetters['RubricBanksView/searchTag'],
                });
            }

            if (rootGetters['RubricBanksView/hasGroupSearch']) {
                queryBuilder.raw({
                    groups: rootGetters['RubricBanksView/searchGroup'],
                });
            }

            if (rootGetters['RubricBanksView/hasViewArchive']) {
                queryBuilder.raw({
                    view_archived: rootGetters['RubricBanksView/searchViewArchive'],
                });
            }
        }),

        fetchOne: collectionHelpers.actions.fetchOne(({ context, queryBuilder }) => {
            const { getters } = context;
            queryBuilder
                .include(['rubricTemplates', 'groups', 'tags'])
                .sort(getters.queryBuilderSorting)
                .setPagination(getters.paginate);
        }),

        /**
         * @param context
         * @param filter
         * @return {Promise<any>}
         */
        async filterAndFetch(context, filter) {
            try {
                await context.dispatch('filter', filter);
                await context.dispatch('purge');
                await context.dispatch('fetch');
            } catch (error) {
                return error;
            }
        },

        updateTags: collectionHelpers.actions.updateModelTags(),

        updateGroups: collectionHelpers.actions.updateModelGroups(),

        removeChecked: collectionHelpers.actions.removeChecked(),
    },

    mutations: {
        UPDATE_TAGS: collectionHelpers.mutations.UPDATE_TAGS,
        UPDATE_GROUPS: collectionHelpers.mutations.UPDATE_GROUPS,
        CLEAR_SORTING: collectionHelpers.mutations.CLEAR_SORTING,
    },
});
